import React from 'react'
import { SvgIcon } from '../svg-icon'

/**
 * Stateless function representing an handShake icon.
 *
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <HandShakeIcon width={24} />
 */
const HandShakeIcon = props => (
    <SvgIcon viewBox="0 0 24 24" {...props}>
        <path
            d={`M21,7L21,7c0,0-1,0-2,0s-3-2-4-2s-5,0-6,0S6,7,5,7S3,7,3,7v0C2.45,7,2,7.45,2,8v5c0,0.55,0.45,1,1,1l1.13,0.01
                c-0.2,0.38-0.15,0.85,0.16,1.17c0.39,0.39,1.03,0.39,1.41,0c-0.39,0.39-0.39,1.03,0,1.41s1.03,0.39,1.41,0
                c-0.39,0.39-0.39,1.03,0,1.41s1.03,0.39,1.41,0l0.77-0.77h0l-0.07,0.07c-0.39,0.39-0.39,1.03,0,1.41c0.39,0.39,1.03,0.39,1.41,0
                l1.11-1.11l0.52,0.52c0.26,0.26,0.6,0.4,0.97,0.4s0.71-0.14,0.97-0.4c0.17-0.17,0.27-0.38,0.33-0.6c0.24,0.18,0.51,0.3,0.82,0.3
                c0.37,0,0.71-0.14,0.97-0.4s0.4-0.6,0.4-0.97c0-0.02-0.01-0.03-0.01-0.05c0.02,0,0.03,0.01,0.05,0.01c0.35,0,0.7-0.13,0.97-0.4
                c0.26-0.26,0.4-0.6,0.4-0.97c0-0.02-0.01-0.03-0.01-0.05c0.02,0,0.03,0.01,0.05,0.01c0.35,0,0.71-0.13,0.97-0.4h0
                c0.22-0.22,0.33-0.5,0.37-0.79C19.73,13.92,19.89,14,20,14c1,0,1,0,1,0c0.55,0,1-0.45,1-1V8C22,7.45,21.55,7,21,7z M18.65,14.06
                c-0.24,0.24-0.64,0.24-0.88,0l-3.41-3.41l-0.53,0.53l3.41,3.41c0.12,0.12,0.18,0.27,0.18,0.44s-0.06,0.32-0.18,0.44h0
                c-0.24,0.24-0.64,0.24-0.88,0l-3.41-3.41l-0.53,0.53L15.82,16c0.12,0.12,0.18,0.27,0.18,0.44s-0.06,0.32-0.18,0.44h0
                c-0.23,0.23-0.65,0.23-0.88,0l-0.71-0.71c0,0,0,0,0,0l-2.7-2.7L11,14l2.7,2.7c0.24,0.24,0.24,0.64,0,0.88
                c-0.24,0.24-0.64,0.24-0.88,0l-0.57-0.57c0.18-0.37,0.13-0.84-0.18-1.14c-0.39-0.39-1.03-0.39-1.41,0c0.39-0.39,0.39-1.03,0-1.41
                c-0.39-0.39-1.03-0.39-1.41,0l0.71-0.71c0.39-0.39,0.39-1.03,0-1.41s-1.03-0.39-1.41,0c0.39-0.39,0.39-1.03,0-1.41
                s-1.03-0.39-1.41,0l-2.08,2.08L3,13V8l2,0c0.8,0,1.65-0.57,2.55-1.17C8,6.53,8.75,6.03,9,6h1.12C9.5,6.5,9,7,9,7
                C8,8,8.54,8.72,9.12,9.3c0.59,0.59,2,0.12,3.16-1.04c0.08-0.08,0.15-0.15,0.22-0.23H13c0.36-0.01,1.23,0.75,2.24,1.72l0,0l3.41,3.41
                C18.89,13.42,18.89,13.81,18.65,14.06z`}
        />
    </SvgIcon>
)

export { HandShakeIcon }
